
import { Home, UserPlus, Users, BarChart, ClipboardList, Database, Building2 } from "lucide-react";
import {
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
} from "@/components/ui/sidebar";
import { Link, useLocation } from "react-router-dom";
import { useUserRoles } from "@/hooks/useUserRoles";
import { useAuthSession } from "@/hooks/useAuthSession";

const AdminMenu = () => {
  const { userId } = useAuthSession();
  const { role } = useUserRoles(userId);
  const location = useLocation();
  
  const menuItems = [
    {
      title: "Admin Home",
      icon: Home,
      href: "/admin",
      showFor: ["admin", "producer"],
    },
    {
      title: "Employees",
      icon: Users,
      href: "/admin/employees",
      showFor: ["admin"],
    },
    {
      title: "Clients",
      icon: ClipboardList,
      href: "/admin/clients",
      showFor: ["admin", "producer"],
    },
    {
      title: "Add New Client",
      icon: UserPlus,
      href: "/admin/new-client",
      showFor: ["admin", "producer"],
    },
    {
      title: "Leads",
      icon: Users,
      href: "/admin/leads",
      showFor: ["admin", "producer"],
    },
    {
      title: "Sales Reports",
      icon: BarChart,
      href: "/admin/sales",
      showFor: ["admin", "producer"],
    },
    {
      title: "Add Fields",
      icon: Database,
      href: "/admin/fields",
      showFor: ["admin"],
    },
  ];

  const filteredMenuItems = menuItems.filter(item => 
    item.showFor.includes(role || 'user')
  );

  return (
    <SidebarMenu>
      {filteredMenuItems.map((item) => (
        <SidebarMenuItem key={item.title}>
          <SidebarMenuButton asChild>
            <Link 
              to={item.href}
              className="hover:bg-primary/10 rounded-md px-2 py-1 transition-all duration-200"
              state={{ source: "admin-menu", role: role }}
            >
              <item.icon className="h-4 w-4 text-primary hover:scale-110 transition-transform duration-200" />
              <span className="hover:text-primary transition-colors duration-200">{item.title}</span>
            </Link>
          </SidebarMenuButton>
        </SidebarMenuItem>
      ))}
    </SidebarMenu>
  );
};

export default AdminMenu;
